import styled from 'styled-components'
import { AuctionDetails } from 'src/features/myOffers/components/atoms'
import { ReservationDetails } from 'src/features/reservations/components/atoms'

export default styled.section`
  position: relative;
  scroll-margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.ghost.alpha(0.4).hex()};
  border-bottom: 1px solid ${({ theme }) => theme.colors.ghost.alpha(0.4).hex()};
  background: ${({ theme }) => theme.colors.white.hex()};

  > div:first-child {
    margin-top: 0 !important;
    margin-left: -4px;
    border-left: 4px solid ${({ theme }) => theme.colors.apple.hex()};
    border-bottom: 0;
    box-shadow: none;

    &:hover {
      box-shadow: none;
    }
  }

  ${ReservationDetails},
  ${AuctionDetails} {
    && {
      margin: 0 !important;
      border-left: 0;
      box-shadow: none;
      background: ${({ theme }) =>
        theme.colors.catskillWhite.alpha(0.25).hex()};
    }

    &:hover {
      box-shadow: none;
    }
  }
`
